<template>
  <div>
    <Banner />
    <section
      class="hero"
      :style="{backgroundImage: `url(${image})`}"
    />
    <section class="content">
      <div class="left">
        <h3>{{ name }}</h3>
        <p>{{ title }}</p>
      </div>
      <div class="right">
        <p
          v-for="descPart in desc.split('\n')"
          :key="descPart"
        >
          {{ descPart }}
        </p>
      </div>
    </section>
    <footer-common />
  </div>
</template>

<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'

export default {
  name: 'Index',
  components: { Banner, FooterCommon },
  data () {
    return {
      desc: null,
      name: null,
      title: null,
      image: null
    }
  },
  mounted: function () {
    switch (this.$route.params.name) {
      case 'acey':
        this.name = 'ACEY SLADE'
        this.title = 'DOPE | MURDERDOLLS | JOAN JETT'
        this.desc = `Acey Slade 是 Acey Slade & the Dark Party 乐队的主唱和吉他手，还曾经是 Joan Jett and the Blackhearts 乐队的前贝斯手。在此之前他是朋克摇滚乐队 Trashlight Vision 的主唱，但这支乐队在 2007 年 9 月 20 号解散了。Slade 最为人熟知的可能要算他曾经是恐怖朋克和华丽金属乐队 Murderdolls 的前吉他手。他还是 The Misfits 乐队的巡演节奏吉他手。目前他住在纽约的布鲁克林。
          在成为 Murderdolls 和 Wednesday 13 乐队成员之前，Slade 是 Dope 乐队的贝斯手，后来又改弹吉他，该乐队的吉他手 Tripp Eisen 也同样是 Murderdolls 乐队的成员。在 Eisen 离开 Dope 乐队之后，Slade 演奏了 Life 专辑中的吉他部分。之后他也离开了 Dope 乐队并加入了 Murderdolls 乐队，并再次取代了 Eisen 吉他手的位置。在加入 Murderdolls 乐队之前（同时伴随着他在 Dope 乐队的工作），Slade 还组建了一个叫做 Vampire Love Dolls 的乐队。在 Murderdolls 乐队于 2004 年解散之后，Slade 作为吉他手参加过朋克/金属乐队 Amen 在日本的巡演。
          在 Roadrunner 唱片公司 25 周年纪念项目 Roadrunner United 的 "Tired 'N Lonely" 歌曲中，Slade 演奏了节奏吉他部分。在这首歌曲中与 Slade 合作的有 Joey Jordison，他也曾在 Murderdolls 乐队里和 Slade 一同演奏过。在 Trashlight Vision 乐队解散后，Slade 作为吉他手参加了 Wednesday 13 乐队在 2008 年的巡演，另外还参与制作了 His Mighty Robot 乐队（尚未发行）和 Billy Liar 乐队的专辑。
          Slade 还曾为电子游戏 Rock Band 2 中的朋克歌手和摇滚吉他手角色担任过动作捕捉模特。
          目前，Slade 正在巡演并推广他的新乐队 Acey Slade & the Dark Party，乐队首张专辑 The Dark Party 发表于 2010 年。同时他还在 Joan Jett & the Blackhearts 乐队里弹贝斯，另外还作为贝斯手参加前乐队 Dope 的偶尔巡演。在 Misfits 乐队原班人马的各种重组演出中 Slade 演奏的是第二吉他。`
        this.image = require('@/assets/artist/artist-acey-banner@2x.png')
        break
      case 'joey':
        this.name = 'JOEY BRADFORD'
        this.title = 'THE USED'
        this.desc = `Joey Bradford（出生于 1987 年 5 月 6 日）是一名美国摇滚音乐人，以美国摇滚乐队 The Used （Hopeless 唱片） 的主音吉他手、Hell or Highwater 乐队（Spinefarm 唱片）的主唱、Thieves and Liars 乐队（Facedown 唱片）的贝斯手和 A Static Lullaby 乐队的巡演贝斯手而为人所熟知。他还参加过 Thrice 乐队和 Atreyu 乐队的重大演出。
          他的音乐生涯开始于南加州，当时他和同学 Cove Reber （Saosin/Dead American 乐队）、Kellen Asebroak （Fruition 乐队） 以及 Victor Wilson 一起在他父母的车库里演奏朋克摇滚。在被吸引到摇滚世界里之后，他在 2005 年作为一名 18 岁的推销员进入了巡演领域，之后毕业成为一名吉他技师，然后最终成为一名全职的乐手。在 2008 年发表的专辑 When Dreams Become Reality 是他迈出的重要的第一步，从而才有了之后的众多作品以及 2018 年成立的 The Used 乐队。`
        this.image = require('@/assets/artist/artist-joey-banner@2x.png')
        break
      case 'stef':
        this.name = 'STEF CARPENTER'
        this.title = 'DEFTONES'
        this.desc = `Stephen "Stef" Carpenter（出生于 1970 年 8 月 3 日）是一名美国音乐人，凭借摇滚乐队 Deftones 的共同创始人和主音吉他手的身份而为人所熟知。
          他在吉他技巧上既利用了余音悠长的空弦又采用了不协和的和弦音符排列，还将常见的强力和弦用在了复合节奏里。Carpenter 的音乐生涯开始于在 Deftones 乐队里演奏传统的 6 弦吉他。在受到像 Fear Factory 和 Meshuggah 这样的乐队影响之后，他在 20 世纪 90 年代末开始演奏 7 弦吉他。在 Deftones 乐队第三张专辑 White Pony 之后发表的作品都是用 7 弦吉他来写的，直到 2010 年的 Diamond Eyes 专辑 和 2012 年的 Koi No Yokan 专辑为止，这两张专辑都是用 8 弦吉他来写的。Carpenter 在《吉他世界》杂志的金属吉他手 100 强的票选中排名第 60。`
        this.image = require('@/assets/artist/artist-stef-banner@2x.png')
        break
      case 'rob':
        this.name = 'ROB CAGGIANO'
        this.title = 'VOLBEAT'
        this.desc = `Rob Caggiano 参加的首支职业乐队 Boiler Room 组建于 1996 年。在 1999 年为 Orgy 乐队做了暖场表演之后，这支乐队吸引了 Roadrunner 唱片公司的注意力。在数次延期之后，Tommy Boy 唱片公司最终发行了这支乐队的首张专辑 Can't Breathe。但紧接着这支乐队就在 2000 年夏天解散了。
          他最初是从 2001 年到 2005 年和 Anthrax 乐队一起演奏，但在乐队原班人马重组做 Among The Living 专辑期间退出，后来在重组结束后的 2007 年又回归乐队。他参与的专辑有 We've Come For You All 和 Worship Music，还有精选合辑 The Greater of Two Evils（以前作品的录音棚现场录音版本）以及现场专辑 Music of Mass Destruction。Rob 还参与了 2010/2011 年期间由 Anthrax、 Slayer、Megadeth 和 Metallica 四支乐队领衔的 The Big 4 巡演。在保加利亚的那场表演不仅在网上进行了直播，还在世界各地的影院中进行了广播，整个 Big 4 演出（Anthrax、 Megadeth、 Slayer 和 Metallica 乐队）的 DVD 于 2010 年 11 月 2 号发行。Rob Caggiano 还凭借唱片制作人/混音师的身份而为人所熟知，他最出名的要算以 Scrap 60 制作公司名义制作的 Cradle of Filth、 Anthrax 和 Jesse Malin 乐队的专辑，以及许多其他著名金属/硬摇滚乐队的专辑。Rob 还是 The Damned Things 乐队的吉他手/歌曲作者，乐队成员还有 Scott Ian （Anthrax 乐队）、Joe Trohman 和 Andy Hurley （Fall Out Boy 乐队）以及 Keith Buckley （Every Time I Die 乐队）。The Damned Things 乐队的首张专辑也同样是由 Rob Caggiano 录音并制作的，这张专辑于 2010 年 12 月 13 号通过 Island 唱片公司发行。
          在 2013 年 1 月 4 号，有消息宣布他退出了 Anthrax 乐队，据报道是为了专注在录音棚制作的工作上。
          在 2013 年 1 月 4 号，有消息宣布 Caggiano 作为主音吉他手正式加入了丹麦乐队 Volbeat。Rob Caggiano 原本是被找去当 Volbeat 乐队新专辑 Outlaw Gentlemen and Shady Ladies 的唱片制作人的，结果在两个星期的录音之后，由于他和其他乐队成员之间产生的奇妙化学反应，他被邀请加入成为乐队的正式成员。`
        this.image = require('@/assets/artist/artist-rob-banner@2x.png')
        break
    }
  },
  methods: {}
}
</script>

<style scoped>
section.hero {
  background-size: cover;
  width: 100%;
  min-height: 440px;
}
section.hero > div > h3 {
  margin: 0;
}

section.content {
  display: flex;
  flex-direction: row;
  width: 60%;
  margin: 0 auto;
  padding: 70px 0;
  justify-content: space-between;
  font-family: Roboto;
}
section.content .left {
  margin: 16px 0;
}
section.content .left > h3, section.content .left > p {
  margin: 0;
  color: white;
}
section.content .left > h3 {
  font-size: 24px;
}
section.content .left > p {
  font-size: 14px;
}
section.content .right {
  width: 64%;
}
@media screen and (max-width: 768px) {
  section.hero {
    min-height: 300px;
    background-position: center;
  }
  section.content {
    width: 95%;
    display: block;
  }
  section.content .right {
    width: 100%;
  }
  section.content .right p:last-of-type {
    margin-bottom: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/artist-info.vue